import * as z from 'zod';

const VictoryProbabilitySchema = z.object({
  home: z.number(),
  draw: z.number(),
  away: z.number(),
});

export default VictoryProbabilitySchema;
